// services/ClassService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

export function getClasses(params = {}) {
    return api.get(ENDPOINTS.CLASSES.BASE, { params });
}
export function getClassById(id) {
    return api.get(ENDPOINTS.CLASSES.BY_ID(id));
}
export function createClass(payload) {
    return api.post(ENDPOINTS.CLASSES.BASE, payload);
}
export function updateClass(id, payload) {
    return api.patch(ENDPOINTS.CLASSES.BY_ID(id), payload);
}
export function deleteClass(id) {
    return api.delete(ENDPOINTS.CLASSES.BY_ID(id));
}
export function restoreClass(id) {
    return api.post(`${ENDPOINTS.CLASSES.BY_ID(id)}/restore`);
}

// Modules affectés à une classe (plusieurs par classe)
export function getClassModules(classId) {
    return api.get(ENDPOINTS.CLASSES.MODULES(classId));
}
export function setClassModules(classId, moduleIds) {
    return api.put(ENDPOINTS.CLASSES.MODULES(classId), { module_ids: moduleIds });
}